import { amplitude } from "@eis-poc/lib-discover-medical-mfes";
/**
 * Handles redirecting user to sign-in page
 * and returns user to location in app they
 * were at before they signed in
 *
 * @param {*} event
 */
export const handleSignInClick = (event) => {
  event.preventDefault();
  if (typeof window !== "undefined") {
    const returnToUrl = encodeURIComponent(window.location.href);
    window.location.assign(`/login?returnToUrl=${returnToUrl}`);
  }
};

/**
 * Handles redirecting user to register page
 * and returns user to location in app they
 * were at before they registered
 *
 * @param {*} event
 */
export const handleRegisterClick = (event) => {
  event.preventDefault();
  if (typeof window !== "undefined") {
    const returnToUrl = encodeURIComponent(window.location.href);
    window.location.assign(`/login?action=register&returnToUrl=${returnToUrl}`);
  }
};

/**
 * Handles redirecting user to subscription purchasing page
 * and returns user to location in app they
 * were at before they signed in
 *
 * @param {*} event
 */
export const handleSubscribeClick = (event) => {
  event.preventDefault();
  if (typeof window !== "undefined") {
    const returnToUrl = encodeURIComponent(window.location.href);
    window.location.assign(`/store?returnToUrl=${returnToUrl}`);
  }
};

/**
 * Handles redirecting user to free-trial page
 * and returns user to location in app they
 * were at before they registered
 *
 * @param {*} event
 */
export const handleFreeTrialClick = (event) => {
  event.preventDefault();
  if (typeof window !== "undefined") {
    window.location.assign(`/store/free-trial`);
  }
};

/**
 * Handles appending a returnToUrl query param to a given url
 *
 * @param {*} url
 */
export const appendReturnToUrl = (url) => {
  if (typeof window !== "undefined" && url) {
    const separator = url.indexOf("?") === -1 ? "?" : "&";
    const returnToUrl = encodeURIComponent(window.location.href);
    return `${url}${separator}returnToUrl=${returnToUrl}`;
  } else {
    return url;
  }
};

/**
 * Handles appending amplitude device ID query param to a given url
 *
 * @param {*} url
 */
export const appendAmplitudeDeviceId = (url) => {
  const deviceId = amplitude.getUserDevice();

  if (typeof window !== "undefined" && url && deviceId) {
    const separator = url.indexOf("?") === -1 ? "?" : "&";
    return `${url}${separator}amp_device_id=${deviceId}`;
  } else {
    return url;
  }
};
